module.exports = __webpack_public_path__ + "img/apidays-live-hongkong.39f93c34.jpg";